import { useState } from 'react';

import { ListaEventoRequest } from 'api/Assessor/evento';
import { Col, Row, Title } from 'plataforma-fundacao-componentes';
import { useSelector } from 'react-redux';
import { IReducer } from 'store/Reducer';
import Filtros from './Filtros';
import Tabela from './Tabela';

import translation from 'locales/translation';
import styles from './styles.module.scss';

export default function HomeAssessor() {
  const [filters, setFilters] = useState<Partial<ListaEventoRequest>>();
  const [hasDateError, setDateErrorFlag] = useState<boolean>(false);

  const auth = useSelector((state: IReducer) => state.auth);

  return (
    <Row className={styles.root}>
      <Row className={styles.container}>
        {auth.logged ? (
          <Row>
            <Row className={styles.title_content_hibrid}>
              <Col>
                <Title showBackButton={false}>
                  {translation.Assessor.TelaInicial.Titulo}
                </Title>
              </Col>
              <Col>
                <p>{translation.Assessor.TelaInicial.Subtitulo}</p>
              </Col>
            </Row>
            <Row>
              <Filtros
                onChangeFilter={setFilters}
                onValidateDate={setDateErrorFlag}
              />
              <Tabela filters={filters} hasDateError={hasDateError} />
            </Row>
          </Row>
        ) : undefined}
      </Row>
    </Row>
  );
}
